export default "__VITE_ASSET__BgNyrz$V__"